import React from "react";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button } from "@mui/material";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import { onMessageListener } from "./firebase";

import "bootstrap/dist/css/bootstrap.min.css";
import Badge from "@mui/material/Badge";

import { SnackbarProvider, useSnackbar } from "notistack";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import avtarPic from "../assets/Images/avtarPic.png";
import sosImg from "../../src/assets/Images/sosImg.png";
// import AddNewSOS from "./pages/ManageSOS/AddNewSOS";
import { Grid } from "@mui/material";
import { makeGetRequest, makePostRequest } from "../../src/utils/utils"
import swal from "sweetalert";
import AddAlertIcon from "@mui/icons-material/AddAlert";

function Top() {
  const navigate = useNavigate();

  // For Modal
  const [open3, setOpen3] = React.useState(false);
  const [scroll3, setScroll3] = React.useState("paper");
  const [SOSList, setSOSList] = React.useState([]);
  const [title, setTitle] = React.useState("");
  const [customMessage, setcustomMessage] = React.useState('');
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [customflag, setCustomFlag] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  const handleClickOpen3 = (scrollType) => () => {
    setOpen3(true);
    setScroll3(scrollType);
    setActiveIndex(null)
    setTitle("")
    getAllSOS();
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  async function getAllSOS() {
    setShowLoader(true);
    await makeGetRequest("commonapis/getAllSos")
      .then((response) => {
        console.log(response);
        if (response.data.status === "1") {
          console.log(response.data.data);

          setSOSList(response.data.data);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", err, "warning");
      });
  }


  async function sendSOS() {
    let jsonObj;
    if (customMessage == "" && title == "") {
      swal(
        "Warning", "Please select any SOS alert or add custom",
        "warning"
      );
      return;
    }
    if (customflag) {
      jsonObj = customMessage;
    } else {
      jsonObj = title;
    }


    let bodyFormData = {
      title: "New Sos Alert",
      message: jsonObj,
      resident_id: localStorage.getItem("userId"),
    };
    setShowLoader(true);

    await makePostRequest("guards/sendNotification", bodyFormData)
      .then((response) => {
        setOpen3(false);
        setTitle("");
        setCustomFlag(false);
        setShowLoader(false);
        setcustomMessage("")
      })
      .catch((err) => {
        setShowLoader(false);
        swal(
          "There was an error in sending Notification!!",
          "more error details",
          "warning"
        );
      });
  }

  const handlecustom = async (e) => {
    setCustomFlag(true);
    setcustomMessage(e.target.value)
  };

  const handleSelectSos = (opt) => {
    setActiveIndex(opt.sos_id);
    setTitle(opt.sos_name)
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open3) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

  }, [open3]);
  // End

  // const [defaultProfilePic, setDefaultProfilePic] = React.useState(
  //   require("../../../assets/Images/avtarPic.png")
  // );

  // For Modal
  const [openModal, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType, id) => () => {
    console.log("Id Returned " + id);
    var tempNotification = lstJsonNotiObj[id];
    setShowNotification(tempNotification);

    setOpen(true);
    setScroll(scrollType);
  };

  const handleCloseModal = (id) => {
    var removed = lstJsonNotiObj.slice(id, 1);
    console.log(removed);
    console.log(id);
    setOpen(false);
  };
  // End

  // For Notifiction
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open2 = Boolean(anchorEl2);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  // End

  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [lstNotification, setLstNotification] = React.useState([]);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //for Notification

  const [show, setShow] = useState(false);
  // const [notification, setNotification] = useState({});
  const [showNotification, setShowNotification] = useState({
    id: "",
    title: "",
    body: "",
  });
  const [notifId, setnotifId] = useState(0);
  const [lstJsonNotiObj, setLstJsonNotiObj] = useState([]);

  const [sosobj, setsosobj] = useState([]);

  let count = 0;

  const { enqueueSnackbar } = useSnackbar();

  onMessageListener()
    .then((payload) => {
      if (!payload || !payload.notification) {
        console.log("No notification payload, skipping:", payload);
        return;
      }
      console.log("In a Listner");
      console.log(payload);
      // count=count+1;
      // setnotifId(count);
      console.log(payload.notification.title);
      let notification = {};

      if (payload.notification.title == "New Sos Alert") {
        notification.title = payload.notification.title;
        var tempVal = payload.notification.body;
        console.log(tempVal);
        notification.body = tempVal;
        localStorage.setItem('showsos', tempVal)
      }
      else if (payload.notification.title == "Extend stay") {
        var jsonObj = payload.data;
        console.log(jsonObj);
        notification.title = payload.notification.title;
        notification.body =
          "Extended Stay of " + jsonObj.fname + " for " + jsonObj.extended_time;
        // localstorag

      }
      else {
        notification.title = payload.notification.title;
        notification.body =
          payload.notification.body;
      }
      lstJsonNotiObj.unshift(notification)
      // setNotification(notification);
      // console.log("Notification ", notification);
      setLstJsonNotiObj(lstJsonNotiObj);
      // lstNotification.push(notification);

      setState({ openTost: true });
      enqueueSnackbar(notification.body);
      setShow(true);
    })
    .catch((err) => console.log("failed: ", err));

  const onShowNotificationClicked = () => {
    // setNotification({
    //   title: "Notification",
    //   body: "This is a test notification",
    // });
    setShow(true);
  };

  // For Tosts
  const [state, setState] = React.useState({
    openTost: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, openTost } = state;

  const [userType, setUserType] = React.useState("");
  const [userName, setUserName] = React.useState("");
  const [profilePic, setProfilePic] = React.useState("");

  useEffect(() => {
    setUserType(localStorage.getItem("userType"));
    setUserName(localStorage.getItem("userName"));
    setProfilePic(localStorage.getItem("profilePic"));
  }, []);

  async function logoutUser() {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  return (
    <>
      <div className="topMain addApartName">
        <div>
          {localStorage.getItem("societyName") ? (
            <h3 className="apartMentTx">
              {localStorage.getItem("societyName")}
            </h3>
          ) : (
            <></>
          )}
        </div>

        <div className="topRi">
          <img
            src={sosImg}
            className="sosStop"
            onClick={handleClickOpen3("body")}
          />
          <Badge
            badgeContent={lstJsonNotiObj.length}
            color="primary"
            onClick={handleClick2}
          >
            <NotificationsNoneIcon
              className="topNoti"
              onClick={() => onShowNotificationClicked()}
            />
          </Badge>
          <Menu
            className="outNotiFic"
            id="basic-menu"
            anchorEl={anchorEl2}
            open={open2}
            onClose={handleClose2}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <ul>
              <li>Notifications</li>
              {lstJsonNotiObj.map((option) => (
                <li>
                  <b>{option.title}</b>
                  <p>{option.body}</p>
                </li>
              ))}
            </ul>
          </Menu>

          <Stack
            direction="row"
            spacing={2}
            className="avtarMain"
            onClick={handleClick}
          >
            {profilePic ? (
              <Avatar alt="Remy Sharp" src={profilePic} />
            ) : (
              <Avatar alt="Remy Sharp" src={avtarPic} />
            )}

            <b>{userName}</b>
            {userType == "SocietyAdmin" ? (
              <span>Society Admin</span>
            ) : (
              <span>{userType}</span>
            )}
            <ArrowDropDownIcon
              className="topDropArrow"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            />
          </Stack>
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => navigate("/UserProfile")}>
            View Profile
          </MenuItem>
          <MenuItem onClick={() => logoutUser()}>Logout</MenuItem>
        </Menu>
      </div>

      <div className="modalMain">
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="notificationModalMain"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Notification</span>
            <CloseIcon className="modalCloseBt" onClick={handleCloseModal} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="notificationViewCont">
              <b>
                {showNotification.title} {showNotification.id}
              </b>
              <p>{showNotification.body}</p>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* SOS */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose}
          scroll={scroll3}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Set SOS</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  {SOSList.map((option) => (
                    <div key={option.sos_id} className={
                      option.sos_id === activeIndex
                        ? "visitContDiv sosContMain activeSOS"
                        : "visitContDiv visitContDivNotice"}
                      onClick={() => handleSelectSos(option)}>
                      <div className="visitCont1 resideNewContOut">
                        <div className="visitContLeft">
                          <h5 className="sosHeadingTx">{option.sos_name}</h5>
                          <p className="visitContTime">
                            {option.sos_description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalInput">
                    <AddAlertIcon />
                    <input className="modalInputSt" placeholder="Send Custom SOS" onChange={(e) => handlecustom(e)}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button className="modalMainBt" onClick={() => sendSOS()}>Send SOS</Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>

        {showLoader &&
          <div className="loaderOter" id="loaderId">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <div className="shadow"></div>
              <span>Loading</span>
            </div>
          </div>}
      </div>
    </>
  );
}

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={3}>
      <Top />
    </SnackbarProvider>
  );
}

// export default Top;
